import type { BrandKitDisplay } from '@rma/dashboard/settings/public/api-brand-kits';

export function getBrandKitLinkMetadata(brandKit: BrandKitDisplay): Record<string, boolean> {
  return {
    brandKitIdHasValue: !!brandKit.id,
    squareLogoUrlHasValue: !!brandKit.squareLogoUrl,
    rectangularLogoUrlHasValue: !!brandKit.rectangularLogoUrl,
    coverImageUrlHasValue: !!brandKit.coverImageUrl,
    primaryColourHasValue: !!brandKit.primaryColour,
    secondaryColourHasValue: !!brandKit.secondaryColour,
    additionalColoursHasValue: !!brandKit.additionalColours,
    fontsHasValue: !!brandKit.fonts,
  };
}
